import { Actions } from 'src/actions/BannerMessage';
import { IBannerMessagePayload } from 'src/Common/Models/BannerMessage';

import { cloneDeep } from 'lodash-es';
import { UATConstants } from 'src/Common/Models/UATConstants';

export const initialState: IBannerMessagePayload = UATConstants.DataSanitizeinitialMessages;
const bannerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Actions.SET_BANNER:
      return { ...state, updateBanner: cloneDeep(action.payload) };
    default:
      return { ...state };
  }
};
export default bannerReducer;
